import { rest } from 'msw'
export default [
  /**
   * コンテンツ一覧情報
   */
  rest.post('/api/v2/get_content_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    const count = 30
    const { page, categoryId } = req.body
    const data = []
    for (let i = 0; i < 150; i++) {
      data.push({
        id: i + 1,
        title: `詳細画面テスト用記事${i + 1}`,
        prflag: i % 2 === 0 ? 0 : 1,
        mainImage:
          'https://static-stg.retailstudio.jp/assets/contents/281/thumbnail_c0b0348f5160ee589ddc5767437c2da5.jpg',
        listImageAttribute: {
          height: 617,
          width: 925,
        },
        detailImageAttribute: {
          height: 2973,
          width: 4460,
        },
        pointType: `✕✕ポイント${i + 1}`,
        point: 50,
        pointLimit: 50000,
        grantedPoint: 50001,
        openDate: '1598281200',
        closeDate: '1609426799',
        chain: {
          id: 7,
          name: '阪急OASIS',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        brand: {
          id: 7,
          name: '阪急OASISブランド',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        category: {
          id: i % 3 === 0 ? 1 : i % 5 === 0 ? 2 : i % 7 === 0 ? 3 : 0,
          name:
            i % 3 === 0
              ? 'タベレバ編集部'
              : i % 5 === 0
              ? 'ピックアップ'
              : i % 7 === 0
              ? '季節'
              : 'すべて',
          key:
            i % 3 === 0
              ? 'tableva'
              : i % 5 === 0
              ? 'pickup'
              : i % 7 === 0
              ? 'season'
              : 'all',
          isPurchaseOnly: 0,
        },
      })
    }
    const filter = categoryId
      ? data.filter(item => item.category.id === categoryId)
      : data
    const totalPage = Math.ceil(filter.length / count)
    const start = (page - 1) * count
    const end = start + count
    const items = filter.slice(start, end)
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          items,
          count,
          totalCount: data.length,
          totalPage,
          responseTime: 1599624477,
        },
      })
    )
  }),
  /**
   * コンテンツカテゴリ一覧情報
   */
  rest.post('/api/v2/get_content_category', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          categories: [
            {
              id: 1,
              name: 'タベレバ編集部',
              key: 'tableva',
            },
            {
              id: 2,
              name: 'ピックアップ',
              key: 'pickup',
            },
            {
              id: 3,
              name: '季節',
              key: 'season',
            },
          ],
        },
      })
    )
  }),
  /**
   * コンテンツ詳細情報
   */
  rest.post('/api/v2/get_content_detail', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          id: 910,
          title: '詳細画面テスト用記事',
          prflag: 1,
          mainImage:
            'https://static-stg.retailstudio.jp/assets/contents/910/main_image_699c168fe04d1c0cef314c16af5fedfd.jpeg',
          mainImageAttribute: {
            height: 480,
            width: 720,
          },
          listImage:
            'https://static-stg.retailstudio.jp/assets/contents/910/thumbnail_8b97c0936978474a29e3ff27b2e5dc3f.jpeg',
          openDate: '1619794800',
          closeDate: '',
          isPurchaseOnly: 0,
          chain: {
            id: 18,
            name: 'マルイ',
            logo:
              'https://static-stg.retailstudio.jp/assets/companies/18/logo.jpg',
          },
          brand: [],
          details: [
            {
              seq: '1',
              type: 'title',
              background: '#9f9cda',
              color: '#5a4646',
              body: 'サブタイトル',
              attribute: [],
            },
            {
              seq: '2',
              type: 'text',
              background: '#bef4c8',
              color: '',
              body:
                '<p>本文テスト  <b>ここは太字 <font color="#de4a4a">ここは太字＋赤字</font></b></p><p><a href="https://mypage-stg.retailstudio.jp/maruilife/11/content/920" target="_blank">リンクが入ります。</a></p><p><br></p>',
              attribute: [],
            },
            {
              seq: '3',
              type: 'image',
              background: '#fe7878',
              color: '',
              body:
                'https://static-stg.retailstudio.jp/assets/contents/910/detail_675be3d77fcf592f0ff324e76d2739be.png',
              attribute: {
                height: '199',
                width: '289',
              },
              url: 'https://mypage-stg.retailstudio.jp/maruilife/11/content',
            },
            {
              seq: '4',
              type: 'quote',
              background: '#fffdd5',
              color: '',
              body:
                '<p>引用テキストです。</p><p><b>ここは太字</b></p><p><font color="#1da6e3">ここは青字</font></p><p><a href="https://mypage-stg.retailstudio.jp/maruilife/11/content/906" target="_blank">ここがリンク</a></p><p>ノーマルテキスト</p>',
              attribute: [],
            },
            {
              seq: '5',
              type: 'kurashiru1',
              background: '#c8cbff',
              color: '',
              body: [
                'https://www.kurashiru.com/recipes/a6fed850-d897-4ced-9855-55168ee50bb8',
              ],
              attribute: [],
            },
            {
              seq: '6',
              type: 'kurashiru3_ver',
              background: '#fad498',
              color: '',
              body: [
                'https://www.kurashiru.com/recipes/1363a830-aabd-4d05-8779-28c1f8d415d1',
                'https://www.kurashiru.com/recipes/c348c6d9-f9b8-4162-8e3e-ad7bde788d3e',
                'https://www.kurashiru.com/recipes/72af1bf5-ca58-492a-9bd9-d5e02a0fed6d',
              ],
              attribute: [],
            },
            {
              seq: '7',
              type: 'kurashiru3_hor',
              background: '#bcbcbc',
              color: '',
              body: [
                'https://www.kurashiru.com/recipes/527aea0c-8037-4c81-a1c1-92720fbf3b59',
                'https://www.kurashiru.com/recipes/44173fe1-a571-4bd4-9ffa-ae883bb2d51f',
                'https://www.kurashiru.com/recipes/dd61530a-d6b1-40f3-9afa-5a5f98551d34',
              ],
              attribute: [],
            },
            {
              seq: '8',
              type: 'caption',
              background: '#38f000',
              body: 'キャプションテスト',
              attribute: [],
            },
            {
              seq: '9',
              type: 'embedded',
              background: '#eca8de',
              body: 'https://www.youtube.com/watch?v=PRf02Vgcdgw',
              attribute: {
                title:
                  '【ハッキリ言って無限です】ミシュランシェフが教える最高に簡単でおいしい神レシピ「無限ペペたま」フルVerはクラシルアプリで先行公開中！【鳥羽周作の◯◯な料理 vol.25 #おうちでsio】クラシル',
                author_name: 'kurashiru [クラシル]',
                author_url: 'https://www.youtube.com/c/kurashiru',
                type: 'video',
                height: 113,
                width: 200,
                version: '1.0',
                provider_name: 'YouTube',
                provider_url: 'https://www.youtube.com/',
                thumbnail_height: 360,
                thumbnail_width: 480,
                thumbnail_url:
                  'https://i.ytimg.com/vi/PRf02Vgcdgw/hqdefault.jpg',
                html:
                  '<iframe width="200" height="113" src="https://www.youtube.com/embed/PRf02Vgcdgw?feature=oembed" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
              },
            },
          ],
          pointType: 'ポイントなし',
          point: null,
          grantedPoint: 0,
          pointLimit: 0,
          isAnswered: 0,
          surveyCount: 6,
          surveys: [
            {
              id: 11,
              seq: 1,
              title: 'アンケート',
              question: 'この商品を購入したことがありますか',
              type: 'yesno',
              answers: [],
              hasFreeText: 0,
            },
            {
              id: 12,
              seq: 2,
              title: 'アンケート',
              question:
                'この商品はどういう時にお買い上げいただくことが多いですか？',
              type: 'checkbox',
              answers: [
                {
                  seq: 1,
                  label: '忙しい時にもう一品簡単に用意したい',
                },
                {
                  seq: 2,
                  label: '子供が大好きな・・・',
                },
              ],
              hasFreeText: 0,
            },
            {
              id: 13,
              seq: 3,
              title: 'アンケート',
              question:
                'この商品はどういう時にお買い上げいただくことが多いですか？',
              type: 'radio',
              answers: [
                {
                  seq: 1,
                  label: '忙しい時にもう一品簡単に用意したい',
                },
                {
                  seq: 2,
                  label: '子供が大好きな・・・',
                },
                {},
              ],
              hasFreeText: 0,
            },
            {
              id: 14,
              seq: 4,
              title: 'アンケート',
              question:
                'この商品はどういう時にお買い上げいただくことが多いですか？',
              type: 'radio',
              answers: [
                {
                  seq: 1,
                  label: '忙しい時にもう一品簡単に用意したい',
                },
                {
                  seq: 2,
                  label: '子供が大好きな・・・',
                },
                {},
                {
                  seq: 5,
                  label: 'その他',
                },
              ],
              hasFreeText: 1,
            },
            {
              id: 15,
              seq: 5,
              title: 'アンケート',
              question: 'この商品を評価してください',
              type: 'star',
              answers: [
                {
                  seq: 1,
                  label: '美味しさ',
                },
                {
                  seq: 2,
                  label: '価格',
                },
                {
                  seq: 3,
                  label: '鮮度',
                },
                {
                  seq: 4,
                  label: '便利さ',
                },
                {},
              ],
              hasFreeText: 0,
            },
            {
              id: 16,
              seq: 6,
              title: 'アンケート',
              question: 'この商品で何かご意見がありましたら、お書きください',
              type: 'freeText',
              answers: [],
              hasFreeText: 0,
            },
          ],
          relatedCount: 4,
          relatedContents: [
            {
              seq: 1,
              id: 941,
              title: 'ページネーションの用のテスト記事',
              mainImage:
                'https://static-stg.retailstudio.jp/assets/contents/941/ca35748b5d11ed7e6c476c39d1ecda48.jpeg',
              listImage:
                'https://static-stg.retailstudio.jp/assets/contents/941/thumb_bc1cc889edb09ee6d619183f069686e5.jpeg',
              category: {
                id: 0,
                name: '',
                key: '',
              },
            },
            {
              seq: 2,
              id: 942,
              title: '発売45年秘話　ふえるわかめちゃん',
              mainImage:
                'https://static-stg.retailstudio.jp/assets/contents/942/main_image_6de6d3c97ec16150bc2d9684be00a76c.png',
              listImage:
                'https://static-stg.retailstudio.jp/assets/contents/942/thumbnail_933713e41eabc32dacb4bb03cda09628.png',
              category: {
                id: 0,
                name: '',
                key: '',
              },
            },
            {
              seq: 3,
              id: 906,
              title: '最大30文字用の記事最大30文字用の記事最大30文字用の記事',
              mainImage:
                'https://static-stg.retailstudio.jp/assets/contents/906/main_image_83d9ca9cadec2f60f4448b85ddbb0463.jpeg',
              listImage:
                'https://static-stg.retailstudio.jp/assets/contents/906/thumbnail_bc0fa41642bf95147c27547a34408604.jpeg',
              category: {
                id: 0,
                name: '',
                key: '',
              },
            },
            {
              seq: 4,
              id: 905,
              title: '小',
              mainImage:
                'https://static-stg.retailstudio.jp/assets/contents/905/main_image_9bfb52770e6fdfb32a2d952ac7709d5b.jpeg',
              listImage:
                'https://static-stg.retailstudio.jp/assets/contents/905/thumbnail_8c083b4b7afbe40a333ba397ab309edc.jpeg',
              category: {
                id: 0,
                name: '',
                key: '',
              },
            },
          ],
          appNo: '018-02-00910',
          responseTime: 1622165730,
        },
      })
    )
  }),
  /**
   * アンケート回答
   */
  rest.post('/api/v2/set_answer', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          status: 1,
          pointStatus: 9,
          responseTime: '915148799',
        },
      })
    )
  }),
]
